package ui.app.rss.instance.detail


import androidx.compose.material3.SnackbarDuration
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import common.frontend.api.Io
import io.Repository
import kotlinx.coroutines.launch
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.err_create_fail_campaign
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.log.logERROR
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState
import tools.await
import tools.printStackTraceInDebug
import ui.snackBarStateGlobal

@VM
class AppRssDetailInstanceVM : NavigationViewModel() {

    private lateinit var scopeUi: AppRssDetailInstanceScope

    var state by mutableDataState<AppRssDetailInstanceScope.Wrapper>()
        private set

    sealed interface Action {
        data object Save : Action
        data object Delete : Action
        companion object {

            @Composable
            fun rememberAction(vm: AppRssDetailInstanceVM): (Action) -> Unit {
                return remember {
                    { act ->
                        when (act) {
                            Save -> vm.save()
                            Delete -> vm.delete()
                        }
                    }
                }
            }
        }
    }

    private fun delete() {
        scope.launch {
            state.entry?.data?.apply {
                runCatching {
                    Repository.api.rss.instanceDelete(item.id)
                }.onSuccess {
                    scopeUi.nav.up()
                }.onFailure {
                    logERROR(it.printStackTrace())
                    snackBarStateGlobal.showSnackbar(
                        duration = SnackbarDuration.Long,
                        withDismissAction = true,
                        message = it.message ?: Res.string.err_create_fail_campaign.await()
                    )
                }
            }
        }
    }

    private fun save() {
        scope.launch {
            state.entry?.data?.also {
                if (scopeUi.args.isCreator) instanceCreate(it)
                else instanceEdit(it)

            }
        }
    }

    private suspend fun instanceCreate(instance: Io.RssInstance) {
        runCatching {
            Repository.api.rss.instanceCreate(instance.item)
        }.onSuccess {
            scopeUi.args.id = it.id
            state = DataState.Result(
                AppRssDetailInstanceScope.Wrapper(instance.copy(item = it))
            )
        }.onFailure {
            logERROR(it.printStackTrace())
            snackBarStateGlobal.showSnackbar(
                duration = SnackbarDuration.Long,
                withDismissAction = true,
                message = it.message ?: Res.string.err_create_fail_campaign.await()
            )
        }

    }

    private suspend fun instanceEdit(instance: Io.RssInstance) {
        runCatching {
            Repository.api.rss.instanceEdit(instance.item)
        }.onSuccess {
            state.entry?.confirmChanges()
        }.onFailure {
            logERROR(it.printStackTrace())
            snackBarStateGlobal.showSnackbar(
                duration = SnackbarDuration.Long,
                withDismissAction = true,
                message = it.message ?: Res.string.err_create_fail_campaign.await()
            )
        }
    }

    fun init(scopeUi: AppRssDetailInstanceScope) {
        this.scopeUi = scopeUi
        if (state is DataState.Result) return

        state = DataState.Loading()
        scope.launch {
            runCatching {
                val data = if (scopeUi.args.isCreator) Repository.api.rss.instanceTemplate(scopeUi.lang)
                else Repository.api.rss.instanceDetail(scopeUi.args.id)

                state = DataState.Result(
                    AppRssDetailInstanceScope.Wrapper(data)
                )
            }.onFailure {
                it.printStackTraceInDebug()
                state = DataState.Error(it.message!!, throwable = it)
            }
        }
    }

    override fun onRelease() {
        state = DataState.Idle()
    }

}
